import { memo } from "react";

import { Box } from "@mui/material";
import { useAppContext } from "../../../context/appContext";
import UserView from "./UserView";

function AdminContent() {
  const { isMobile } = useAppContext();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center", // ✅ center everything
        width: "100%",
        px: { xs: 2, sm: 2 },
        py: isMobile ? 1 : 2,
        gap: isMobile ? 1 : 3,
      }}
    >
      {/* ✅ inner container */}

      <Box
        sx={{
          width: isMobile ? "95%" : "100%",
          mx: "auto", // ✅ center horizontally
          display: "flex",
          flexDirection: "column",
          gap: isMobile ? 2 : 3,
          mb: "3rem",
        }}
      >
        <UserView />
      </Box>
    </Box>
  );
}

export default memo(AdminContent);
